import { render, staticRenderFns } from "./InstituitionUserProfile.vue?vue&type=template&id=76c62751"
import script from "./InstituitionUserProfile.vue?vue&type=script&lang=js"
export * from "./InstituitionUserProfile.vue?vue&type=script&lang=js"
import style0 from "./InstituitionUserProfile.vue?vue&type=style&index=0&id=76c62751&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports